let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aMMhv")).then(() => parcelRequire('l5aUM'));